import React, { createContext, FC, useContext } from 'react';
import { Subject } from 'rxjs';
import { MainSource } from '../../constants/Source';
import { createHOCWithHookInside } from '../hoc/createHOCWithHookInside';
import { MediaManagerSDKAnyItem } from '../media-manager-sdk';

const dropOnSidebarObservable = new Subject<{ items: MediaManagerSDKAnyItem[]; target: MainSource }>();
const handleDropOnSidebar = (target, items) => dropOnSidebarObservable.next({ items, target });

interface IDropOnSidebarContext {
  dropOnSidebarObservable: typeof dropOnSidebarObservable;
  handleDropOnSidebar: (target: MainSource, items: MediaManagerSDKAnyItem[]) => void;
}

const DropOnSidebarContext = createContext<IDropOnSidebarContext>({
  dropOnSidebarObservable,
  handleDropOnSidebar: () => {},
});

export const DropOnSidebarProvider: FC = ({ children }) => (
  <DropOnSidebarContext.Provider value={{ dropOnSidebarObservable, handleDropOnSidebar }}>
    {children}
  </DropOnSidebarContext.Provider>
);

export const useDropOnSidebar = () => {
  const { dropOnSidebarObservable, handleDropOnSidebar } = useContext(DropOnSidebarContext);

  return { dropOnSidebarObservable, handleDropOnSidebar };
};

/**
 * @deprecated use "useDropOnSidebar"
 */
export const withDropOnSidebar = createHOCWithHookInside('WithDropOnSidebar', useDropOnSidebar);
